import React from "react";
import { observer } from "mobx-react-lite";
import { useApp } from "../context";

import { tsParticles } from "tsparticles";
import Waves from "./Waves/Waves";

export const AnimatedBackground = observer(function AnimatedBackground() {
  const app = useApp();
  const ref = React.useRef<HTMLCanvasElement>(null);
  const vanta = React.useRef<any>(null);

  return (
    <Waves
      lineColor="rgba(0.2, 0.2, 0.2, 0.2)"
      backgroundColor="#fff"
      waveSpeedX={0.09}
      waveSpeedY={0.01}
      waveAmpX={30}
      waveAmpY={30}
      friction={0.5}
      tension={0.1}
      maxCursorMove={40}
      xGap={12}
      yGap={12}
    />
  )
});
